<template>
    <div class="col-sm-3 m-t-15">
        <p>
            <strong>{{ $t('exchange_rate') }}:</strong>
            {{ (1 / quotation.exchange_rate).toFixed(2) | pmlFormatCurrencyById(tenant.currency_id) }}
        </p>
        <p v-if="quotation.due_date_at">
            <strong>{{ $t('due_date') }}:</strong> {{ quotation.due_date_at | pmlDate('DD/MM/YYYY') }}
        </p>
        <h4 class="t_center m-t-25">{{ $t('summary') }}</h4>
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th class="t_center w_50">{{ $t('description') }}</th>
                    <th class="t_right">{{ $t('total') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th class="t_right">{{ $t('products') }}</th>
                    <th class="t_right">
                        {{ quotation.total_products | pmlFormatCurrencyById(tenant.currency_id) }}
                        <small class="show f_normal" v-if="tenant.currency_id != quotation.currency_id">
                            ({{ quotation.total_products * quotation.exchange_rate | pmlFormatCurrencyById(quotation.currency_id) }})
                        </small>
                    </th>
                </tr>
                <tr>
                    <th class="t_right text-danger">{{ $t('discounts') }}</th>
                    <th class="t_right text-danger">
                        {{ quotation.total_discounts | pmlFormatCurrencyById(tenant.currency_id) }}
                        <small class="show f_normal" v-if="tenant.currency_id != quotation.currency_id">
                            ({{ quotation.total_discounts * quotation.exchange_rate | pmlFormatCurrencyById(quotation.currency_id) }})
                        </small>
                    </th>
                </tr>
                <tr>
                    <th class="t_right">{{ $t('taxes') }}</th>
                    <th class="t_right">
                        {{ quotation.total_taxes | pmlFormatCurrencyById(tenant.currency_id) }}
                        <small class="show f_normal" v-if="tenant.currency_id != quotation.currency_id">
                            ({{ quotation.total_taxes * quotation.exchange_rate | pmlFormatCurrencyById(quotation.currency_id) }})
                        </small>
                    </th>
                </tr>
                <tr>
                    <th class="t_right t_uppercase"><h4 class="m-0 bold">{{ $t('total') }}</h4></th>
                    <th class="t_right">
                        <h4 class="m-0 bold">
                            {{ quotation.total_products + quotation.total_discounts + quotation.total_taxes | pmlFormatCurrencyById(tenant.currency_id) }}
                            <small class="show f_normal" v-if="tenant.currency_id != quotation.currency_id">
                                ({{ (quotation.total_products + quotation.total_discounts + quotation.total_taxes) * quotation.exchange_rate | pmlFormatCurrencyById(quotation.currency_id) }})
                            </small>
                        </h4>
                    </th>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'EditQuotation',
        props: [ 'quotation' ],
        computed: {
            ...mapGetters({
                'tenant': 'getTenant'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/edit/Summary.vue